import QRCodeStyling from 'qr-code-styling';
import { useEffect, useState } from 'react';

import TPLogo from '#/tp.png';
import { buildGameUrl } from '@/common/utils/code-gen';
import { resetEventLoop } from '@/common/utils/promise';
import { fadeIn, fullSize } from '@toilet-paper-games/ui';

const qrCode = new QRCodeStyling({
  width: 500,
  height: 500,
  type: 'svg',
  dotsOptions: {
    // color: '#000000',
    gradient: {
      type: 'linear',
      rotation: 35,
      colorStops: [
        {
          offset: 0,
          color: '#d4fcff',
        },
        {
          offset: 1,
          color: '#9cc0e0',
        },
      ],
    },
    type: 'rounded',
  },
  backgroundOptions: {
    color: 'none',
  },
  imageOptions: {
    imageSize: 0.2,
  },
});

export interface QRCodeProps {
  code: string | number;
  onImageLoad?: (image: string | null) => void;
}

export function QRCode(props: QRCodeProps) {
  const { code, onImageLoad } = props;
  const [image, setImage] = useState<string | null>(null);

  useEffect(() => {
    const url = buildGameUrl(code);

    qrCode.update({
      data: url,
    });

    // Resetting event loop to fix a bug in qr-code generation
    resetEventLoop(() =>
      qrCode.getRawData('png').then((rawImage) => {
        if (!rawImage) return;
        const reader = new FileReader();
        reader.readAsDataURL(rawImage as Blob);

        reader.onloadend = () => {
          // Can be ensured to be a string because of readAsDataURL
          const result = reader.result as string | null;

          setImage(result);
          onImageLoad?.(result);
        };
      }),
    );
  }, [code]);

  return (
    <div css={[{ lineHeight: 0, aspectRatio: '1' }, fullSize]}>
      {image && (
        <img src={image} alt="QR Code to scan to join game" css={[fadeIn(), fullSize]} />
      )}
    </div>
  );
}
